// extracted by mini-css-extract-plugin
module.exports = {"container":"_2g2ZhV","img":"_3ZGXnG","text":"_3qxFov"};